<mat-radio-group [(ngModel)]="value" (ngModelChange)="onSelectionChange($event)" [disabled]="disabled" [color]="color" (blur)="onBlur()">
  <div *ngFor="let option of options">
    <mat-radio-button [value]="option.value" [color]="color" [name]="name" [disabled]="option.disabled || disabled">
      <span class="small">{{ option.label }}</span>
    </mat-radio-button>
  </div>
</mat-radio-group>
